import React from "react";
import {observer} from "mobx-react-lite";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {ConsentDocumentDetail} from "./consentDocumentDetail";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const DocumentDetailPage = observer(() => {
  const nursingHomeId = nursingHomeStore.getId();
  return <ConsentDocumentsLayout>{nursingHomeId
    ? <ConsentDocumentDetail key={nursingHomeId} nursingHomeId={nursingHomeId}/>
    : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home to view this consent document."/>
  }</ConsentDocumentsLayout>;
});
